// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store.js'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Content from '@/components/Content'
import Default from '@/components/Default'
import Print from '@/components/Print'
import '@/assets/css/material-components-web.min.css'
import '@/assets/css/icon.css'
import '@/assets/css/fonts.css'
import '@/assets/css/bootstrap.min.css'
import '@/assets/css/style-default.css'
import '@/assets/css/content-layout/css/style.css'
import '@/assets/css/content-layout/css/font-awesome/css/font-awesome.min.css'
Vue.use(VueAxios, axios)
Vue.config.productionTip = false
Vue.component('Default-layout', Default)
Vue.component('Content-layout', Content)
Vue.component('Print-layout', Print)
/* eslint-disable no-new */
var vm = new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')

window.vm = vm
window.$ = window.jQuery = require('jquery')



// WEBPACK FOOTER //
// ./src/main.js